import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=229a48f2&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=229a48f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a48f2",
  null
  
)

export default component.exports